import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';
import indigo from '@material-ui/core/colors/indigo';

const styles = {appBar: {}, btn: ""};
const hostname = window && window.location && window.location.hostname;

if (hostname === 'favacbid.airwis.com') {
    styles.appBar = { backgroundColor: null }; // default material ui blue
    styles.btn = indigo[800];
} else if (hostname === 'favacbidtest.airwis.com') {
    styles.appBar = { backgroundColor: green[500] };
    styles.btn = green[800];
} else {
    styles.appBar = { backgroundColor: red[500] };
    styles.btn = red[800];
}

export const CUSTOM_STYLE = styles;
